export const adaptUserToAutocompleteOption = (user) => {
  return { label: user?.name || user.email, value: user?.username };
};

export const adaptGroupToautocompleteOption = (group) => {
  return { label: group?.name, value: group?.name };
};
